import React, { useState } from 'react';
import styled from 'styled-components';
import { moneyFormat } from '@helpers';
import { Button } from 'fpay-ui';
import { useHistory } from 'react-router';
import * as Routes from '@constants/routes';
import { useBankAccount } from '@hooks';
import { useTranslation } from 'react-i18next';
import { capitalize } from '@helpers/utils';
import { isCountryPeru } from 'constants/regions';
import { extractCciFromBankAccount } from 'helpers/bankAccount';
import { useSelector } from 'react-redux';

const Card = styled.div`
  width: 100%;
  max-width: 504px;
  border-radius: 8px;
  padding: 24px;
  background-color: #ffffff;
  box-shadow: 0px 4px 3px 0px rgba(18, 18, 18, 0.03);
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 500;
  line-height: 20px;
  color: #333333;
  @media (min-width: 600px) {
    font-size: 18px;
  }
`;

const Subtitle = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;
  color: #505050;
  margin-top: 8px;
  @media (min-width: 600px) {
    font-size: 14px;
  }
`;

const ContainerData = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 16px;
  border-radius: 6px;
  padding: 24px;
  width: 100%;
  background-color: #f2f5f9;
`;

const MountTitle = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #333333;
  line-height: 20px;
  @media (min-width: 600px) {
    font-size: 16px;
  }
`;

const Amount = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #333333;
  line-height: 20px;
  @media (min-width: 600px) {
    font-size: 24px;
  }
`;

const DisplayData = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 100%;
  align-items: flex-start;
  flex-direction: column;
  margin-top: ${(props) => (props.firstLine ? '0px' : '12px')};
  @media (min-width: 600px) {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin-top: ${(props) => (props.firstLine ? '0px' : '16px')};
  }
`;

const DataToDisplay = styled.div`
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  @media (min-width: 600px) {
    font-size: 16px;
  }
`;

const ContainerButtons = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 16px;
  @media (min-width: 600px) {
    justify-content: flex-end;
  }
`;

const CheckoutFoundsOut = ({ handleWithdraw, amountToShow }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { bankAccount } = useBankAccount();
  const cci = isCountryPeru && extractCciFromBankAccount(bankAccount);
  const { transactionInProgress } = useSelector((state) => state.transactions);
  const isProcessing = transactionInProgress;
  return (
    <Container>
      <Card>
        <Title>{t('paymentsFoundsOut.check.title')}</Title>
        <Subtitle>{t('paymentsFoundsOut.check.subTitle')}</Subtitle>
        <ContainerData>
          <DisplayData firstLine>
            <MountTitle>{t('paymentsFoundsOut.check.mount')}</MountTitle>
            <Amount>{moneyFormat(amountToShow)}</Amount>
          </DisplayData>
          <DisplayData>
            <DataToDisplay>
              {isCountryPeru ? t('paymentsFoundsOut.check.cci') : t('paymentsFoundsOut.check.bank')}
            </DataToDisplay>
            <DataToDisplay>
              {isCountryPeru ? cci : bankAccount.account_data.account_number}
            </DataToDisplay>
          </DisplayData>
          <DisplayData>
            <DataToDisplay>{t('paymentsFoundsOut.check.bankTitle')}</DataToDisplay>
            <DataToDisplay>
              {capitalize(bankAccount.bank_data.finantial_institution_name)}
            </DataToDisplay>
          </DisplayData>
        </ContainerData>
        <ContainerButtons>
          <Button
            type="outlined"
            borderRadius="40px"
            size="mediumBold"
            color="black"
            margin="0 16px 0 0"
            onClick={() => history.push(Routes.DO_FUNDS_OUT)}
          >
            {t('paymentsFoundsOut.check.back')}
          </Button>
          <Button
            type="button"
            borderRadius="40px"
            size="mediumBold"
            color="gbrand500"
            margin="0"
            onClick={handleWithdraw}
            disabled={isProcessing}
          >
            {isProcessing
              ? t('paymentsFoundsOut.check.processing')
              : t('paymentsFoundsOut.check.confirm')}
          </Button>
        </ContainerButtons>
      </Card>
    </Container>
  );
};

export default CheckoutFoundsOut;
